import { NavLink } from 'react-router-dom';

const TABS = [
  {
    id: 'presences',
    label: 'Présences',
    to: '/equipe/presences',
    end: false,
  },
  {
    id: 'gestion',
    label: "Gestion de l'équipe",
    to: '/equipe',
    end: true,
  },
];

const TAB_CLASS = ({ isActive }) =>
  `rounded-lg px-4 py-2 text-sm font-semibold transition ${
    isActive
      ? 'bg-white text-violet-700 shadow-sm ring-1 ring-violet-100'
      : 'text-gray-600 hover:text-gray-900'
  }`;

export default function TeamUniverseNav({ subtitle, actions = null }) {
  return (
    <div className="space-y-3">
      <div className="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
        <div className="min-w-0">
          <h1 className="text-2xl font-bold text-gray-900">Mon équipe</h1>
          {subtitle ? <p className="mt-1 max-w-2xl text-sm text-gray-600">{subtitle}</p> : null}
        </div>
        {actions ? <div className="shrink-0">{actions}</div> : null}
      </div>
      <nav
        className="inline-flex max-w-full flex-wrap rounded-xl bg-gray-100 p-1"
        aria-label="Vues Mon équipe"
      >
        {TABS.map((tab) => (
          <NavLink key={tab.id} to={tab.to} end={tab.end} className={TAB_CLASS}>
            {tab.label}
          </NavLink>
        ))}
      </nav>
    </div>
  );
}
